import React, { ReactNode } from 'react';
import cx from 'classnames';
import './BaseSectionMessage.less';

type Props = {
  title?: string;
  message: string | ReactNode;
  className?: string;
  type: 'info' | 'success' | 'error' | 'warning';
};

export default function BaseSectionMessage(props: Props) {
  const { type, title, message, className = '' } = props;

  const getMessageIcon = () => {
    switch (type) {
      case 'success':
        return 'icon-check-outlined';
      case 'error':
        return 'icon-closed-outlined';
      case 'warning':
        return 'icon-attention-outlined';
      case 'info':
      default:
        return 'icon-info-outlined';
    }
  };

  return (
    <div className={cx(`section-message section-message-${type}`, className)}>
      <div className="icon-wrapper">
        <span className={cx('icon', getMessageIcon())} />
      </div>

      <div className="content">
        {title && <div className='title'>{title}</div>}
        <div>{message}</div>
      </div>
    </div>
  );
}
